import {EngineScenario} from './EngineScenario';

export class EngineOperation {
code: string;
event: string;
keepInProcessContext: boolean | null;
operations: string[];
prepareValue: string;
scenario: EngineScenario;
}

